<script>
  import ApplicationState from "../../../../Stores/applicationStates"
  import { createEventDispatcher, onMount } from "svelte"
  const dispatch = createEventDispatcher()
  import { querystring } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import { checkValidOlderDate } from "../../../../Pages/Publish/SinglePublish/script"
  import notify from "../../../../Script/notify"

  /**
   * @type {Boolean} whether to show or not a filter component
   */
  export let showFilterForm

  /**
   * @type {Object} - object get from window location
   */
  let query

  /**
   * @type {String} start date for stats
   */
  let startDate

  /**
   * @type {String} end date for stats
   */
  let endDate

  /**
   * @type {Number} to calculate the indian timezone
   */
  const timeZoneOffsetMilliseconds = new Date().getTimezoneOffset() * 60000 // Convert minutes to milliseconds

  /**
   * @type {dateValidation} - document releasing notification
   */
  let dateValidation = {
    close() {},
  }

  /**
   * Initial values are assigned
   */
  onMount(() => {
    query = queryStringToJSON($querystring)

    // const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

    startDate = query.sdate ? new Date(query.sdate).toISOString().slice(0, 10) : ""
    endDate = query.edate ? new Date(query.edate).toISOString().slice(0, 10) : ""
    // startDate = query.sdate ? new Date(new Date(query.sdate).getTime() - timeZoneOffsetMilliseconds).toISOString().slice(0, 16) : new Date(new Date("2021-09-07T00:00:00Z").getTime() + timeZoneOffsetMilliseconds).toISOString().slice(0, 16)
    // endDate = query.edate ? new Date(new Date(query.edate).getTime() - timeZoneOffsetMilliseconds).toISOString().slice(0, 16) : new Date(Date.now() - timeZoneOffsetMilliseconds).toISOString().slice(0, 16)
  })

  $: fetchDate(showFilterForm)

  const fetchDate = () => {
    query = queryStringToJSON($querystring)

    startDate = query.sdate ? new Date(query.sdate).toISOString().slice(0, 10) : ""
    endDate = query.edate ? new Date(query.edate).toISOString().slice(0, 10) : ""
  }

  /**
   * @description - fuction for checking the given date is valid
   */
  const checkDate = (e) => {
    dateValidation.close()
    let value = ""
    let response = checkValidOlderDate(e)
    if (!response) {
      e.target.value = ""
      const info = "PAGE: Analytics Date Filter\nEVENT: On selecting a future date in the date input."
      dateValidation = notify.danger("Don't select future date", info)
    } else value = e.target.value
    return value
  }

  /**
   * @description - filter list data  useing start date and end date
   */
  const filterList = () => {
    let date = {}
    startDate ? (date.startDate = new Date(startDate).toISOString()) : (date.startDate = "")
    endDate ? (date.endDate = new Date(endDate).toISOString()) : (date.endDate = "")
    if (startDate || endDate) dispatch("changeEntries", date)
    showFilterForm = false
  }

  const validateDate = () => {
    if (new Date(startDate) > new Date(endDate)) {
      startDate = ""
      endDate = ""
      const info = "PAGE: Analytics Date Filter\nEVENT: On selecting 'To Date' before 'From Date'"
      dateValidation = notify.danger("The 'To Date' should not precede or be earlier than the 'From Date'.", info)
    }
  }
</script>

<div class=" w-auto space-y-3 rounded-md border border-[#a0a1a580] bg-white px-3 pb-3 pt-3 shadow-md dark:bg-lightgray sm:px-6 sm:pt-6">
  <div class="flex items-center gap-3 text-xl dark:text-slate-200">
    <i class="fa-solid fa-filter-list" />
    <span class="text-lg font-semibold">Filter</span>
  </div>
  <div class="p-2">
    <div class="flex items-center pt-6">
      <div class="relative w-1/2 border-r border-[#a0a1a580] pr-3">
        <input
          on:input={(e) => {
            startDate = checkDate(e)
            validateDate()
          }}
          type="date"
          bind:value={startDate}
          style="color-scheme: {$ApplicationState.darkMode ? 'dark' : 'light'} ;"
          class="dateInput z-20 w-full border-none bg-transparent text-xs font-bold text-blue-500 outline-none placeholder:font-normal placeholder:text-blue-500 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 sm:pl-9 sm:pt-2 sm:text-sm"
        />
        <div class="absolute -top-2 left-1 z-10 hidden text-xl text-blue-500 sm:block">
          <i class="fa-solid fa-calendar-days text-base sm:text-2xl" />
        </div>
        <p class="absolute -top-4 text-xs dark:text-slate-200 sm:left-9 sm:text-sm">From Date</p>
      </div>
      <div class="relative ml-3 w-1/2">
        <input
          on:input={(e) => {
            endDate = checkDate(e)
            validateDate()
          }}
          type="date"
          bind:value={endDate}
          style="color-scheme: {$ApplicationState.darkMode ? 'dark' : 'light'} ;"
          class="dateInput z-20 w-full border-none bg-transparent text-xs font-bold text-blue-500 outline-none placeholder:font-normal placeholder:text-gray-500 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 sm:pl-9 sm:pt-2 sm:text-sm"
        />
        <div class="absolute -top-2 left-1 z-10 hidden text-2xl text-blue-500 sm:block">
          <i class="fa-solid fa-calendar-days text-base sm:text-2xl" />
        </div>
        <p class="absolute -top-4 text-xs dark:text-slate-200 sm:left-9 sm:text-sm">To Date</p>
      </div>
    </div>
  </div>

  <div class="flex justify-between border-t border-[#a0a1a580] px-2 pt-3">
    <button
      on:click={() => {
        showFilterForm = false
        // sortData = jsonData
      }}
      class="flex h-9 w-full cursor-pointer items-center justify-center px-2 text-base font-medium text-red-500 hover:text-red-600 focus:outline-none active:text-red-500 disabled:cursor-not-allowed disabled:text-red-300 lg:px-4"
    >
      <i class="fa-solid fa-xmark" />
      Close
    </button>
    <button
      on:click={() => {
        showFilterForm = false
        startDate = ""
        endDate = ""
        dispatch("reset")
        // let a = 24 * 60 * 60 * 1000 * 7
        // let b = new Date().getTime()
        // startDate = new Date(new Date(new Date(b - a).toISOString()).getTime() - timeZoneOffsetMilliseconds).toISOString().slice(0, 16)
        // endDate = new Date(new Date(new Date(Date.now()).toISOString()).getTime() - timeZoneOffsetMilliseconds).toISOString().slice(0, 16)
        // filterList()
      }}
      class="flex h-9 w-full cursor-pointer items-center justify-center border-l border-[#a0a1a580] px-2 text-base font-medium text-blue-500 hover:text-blue-600 focus:outline-none active:text-blue-500 disabled:cursor-not-allowed disabled:text-blue-300 lg:px-4"
    >
      <!-- One day in MilliSecond 86400000 -->
      <i class="fa-solid fa-rotate-left" />
      Reset
    </button>
    <button
      disabled={!startDate || !endDate}
      on:click={() => {
        filterList()
      }}
      class="flex h-9 w-full cursor-pointer items-center justify-center border-l border-[#a0a1a580] px-2 text-base font-medium text-green-500 hover:text-green-600 focus:outline-none active:text-green-500 disabled:cursor-not-allowed disabled:text-green-300 lg:px-4"
    >
      <i class="fa-solid fa-check" />
      Apply
    </button>
  </div>
</div>

<style>
  input.dateInput {
    position: relative;
  }
  /* datetime-local */
  input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }
</style>
